const roller_directions = ['open', 'stop', 'close', 'position'];

export const _init_group_actions = {
	relay: () => {
		return [
			{
				title: 'collapse_title_change_state',
				id: 'turn',
				i18tr: 'turn',
				values: ['on', 'off'],
			},
		];
	},
	light: () => {
		return [
			{
				title: 'collapse_title_change_state',
				id: 'turn',
				i18tr: 'turn',
				values: ['on', 'off'],
			},
		];
	},
	roller: () => {
		return [
			{
				title: 'collapse_title_change_state',
				id: 'direction',
				i18tr: 'roller_direction',
				values: roller_directions, //, more: 'roller'
			},
			{
				title: 'collapse_title_set_position',
				id: 'position',
				i18tr: 'roller position',
			},
		];
	},
};
